import { nanoid } from "nanoid"

import type { SimpleMesh2d } from ".."
import { nameShape } from ".."
import { matchAdjacentPairs } from "../../matching"
import type { Face2dComputed, Node2d } from "../../mesh"

export const polygonToMesh = (
  face: Face2dComputed,
  makeId: (node: Node2d, idx: number) => string = () => nanoid(),
): SimpleMesh2d => {
  const { nodes } = face
  const nodeEntries = nodes.map(
    (node, idx) => [makeId(node, idx), node] as const,
  )
  const edgeEntries = matchAdjacentPairs(
    nodeEntries,
    ([idA], [idB]) =>
      [nameShape(idA, idB), { node1id: idA, node2id: idB }] as const,
  )
  const mesh = {
    nodes: Object.fromEntries(nodeEntries),
    edges: Object.fromEntries(edgeEntries),
  }

  return mesh
}
